import script from "./MyPageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPageView.vue?vue&type=script&setup=true&lang=ts"

import "./MyPageView.vue?vue&type=style&index=0&id=1266907c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1266907c"]])

export default __exports__